<template>
    <div>
        <div class="bar-box">
            <van-nav-bar
                left-arrow
                left-text="返回"
                @click-left="goHome"
            />
        </div>
        <div class="tab-list">
        <van-tabs 
            v-model="active" 
            background="rgb(25, 29, 56)"
            color="#f9fde4"
            title-active-color="#f9fde4"
            title-inactive-color="#a4b1e8"
            swipeable
            lazy-render
            @click="activeTab"
        >
            <van-tab :key="article.id" v-for="article in articleList" :title="article.name">
                <ArticleListItem 
                    :key="item.id" 
                    v-for="(item,index) in article.article"
                    :title="item.title"
                    @click.native="handleClick(item.id)"
                    v-show="index < limit"
                ></ArticleListItem>
                <div class="btn-more" v-if="article.article.length > limit">
                    <van-button 
                        block
                        color="#002949" 
                        type="primary" 
                        size="small"
                        @click="viewMore"
                    >查看更多</van-button>
                </div>
            </van-tab>
        </van-tabs>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Article from './Article'
import Footer from './Footer'
import ArticleListItem from './ArticleListItem'

export default {
    data() {
        return {
            limit: 10,
            showMore: this.$store.getters.getShowMore,
            active: this.$store.getters.getActiveTab,
            articleList: this.$store.getters.getArticleList,
            page: this.$store.getters.getCurrentPage,
            pageSize: this.$store.getters.getPageSize
        }
    },
    components: {
        Article,
        ArticleListItem,
        Footer
    },
    methods: {
        goHome() {
            this.$router.push('/');
        },
        activeTab(index){
            this.$store.commit('activeTab', index)
            let articleList = this.$store.getters.getArticleList
            this.$store.commit('currentCate',articleList[index].category_id)
        },
        viewMore(){
            this.limit += 5
        },
        handleClick(id){
            this.$router.push({ name: 'articleDetail', params: { id: id }});
        },
    }
}
</script>

<style scoped>
.tab-list{
    min-height: calc(100vh - 276px);
    /* margin-top: 46px; */
}
.btn-more{
    padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/mjwy/home/ArticleList.vue